import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import useStyles from './LabelWithBar.style';

export type LabelWithBarSize = 'small' | 'big';

export interface LabelWithBarProps {
  text: string;
  color: string | undefined;
  size?: LabelWithBarSize;
  withTitle?: boolean;
  titleText?: string;
  className?: string;
  testId?: string;
}

const LabelWithBar: React.FC<LabelWithBarProps> = ({
  text,
  color,
  size = 'small',
  withTitle = false,
  titleText,
  className,
  testId
}) => {
  const c = useStyles({ color, size });
  const [t] = useTranslation('components');

  return (
    <div className={clsx(c.root, className)} data-testid={testId}>
      {withTitle && (
        <span className={c.titleLabel}>
          {titleText || t('fund-list.fundType')}
        </span>
      )}
      <span className={c.textWithBar}>{text}</span>
    </div>
  );
};

export { LabelWithBar };
